<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="proprietarios" :loading="loading">
      <template v-slot:item.responsaveis="{item}">
        <v-tooltip bottom v-if="item.responsaveis.length > 0">
          <template v-slot:activator="{on}">
            <span
              v-on="on"
            >{{item.responsaveis.length}} usuário{{item.responsaveis.length > 1 ? 's' : '' }}</span>
          </template>
          <span>{{item.responsaveis.map(r => r.usuario.nome).join(', ') }}</span>
        </v-tooltip>
        <span v-else>-</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small text @click="editar(item.id)">
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        { text: "Descrição", value: "descricao" },
        {
          text: "Responsáveis",
          value: "responsaveis",
          align: "center",
          sortable: false
        },
        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      loading: true
    };
  },
  computed: mapState({
    proprietarios: state => state.documento.proprietarios
  }),
  methods: {
    editar(id) {
      this.$router.push({
        name: "tipo-proprietario-doc-formulario-editar",
        params: { id }
      });
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Parâmetros: Tipos de proprietário de documento"
    });

    try {
      await this.$store.dispatch("documento/listarProprietarios");
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
};
</script>
